import React from "react";
import { Table as AntTable } from "antd";

function Table(props) {
  return <AntTable {...props} />;
}

export default Table;
